/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-operators */
import { PageIcon } from '@/types';
import FabricCanvasExercise, { Props } from '../fabricexercise';
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric';
class FindCorrectOne extends FabricCanvasExercise {
  private options: PageIcon[] = []; // Kaynak veriler
  selectedTool: string ='';
  configureCanvas(props: Props) {
    const canvas = this._canvas;
    const currentPageItem = props.currentPageItem;
    this.selectedTool = props.tool ?? '';
    const sources = [];
    if (currentPageItem.sources) {
      this.options = currentPageItem.sources;
    }
    const backgroundCoordinate= this._canvas.getBackgroundImageCoordinate();
    for (const option of this.options) {
      const left = backgroundCoordinate.imgLeft + option.x;
      const top = backgroundCoordinate.imgTop +option.y;
      const s = new fabric.Rect({
        width: option.width,
        height: option.height,
        optiongroup: option.group,
        isCorrect: option.isCorrect,
        strokeWidth: 1,
        rx: 8,
        ry: 8,
        opacity: 1,
        stroke: '#22577a',
        fill: '',
        left,
        top,
        id: `source-${option.id}`,
        name: `source-${option.id}`,
        erasable: false,
        selectable: false,
        hasControls: false,
        pageIcon: true,
        hasBorders: false,
        optionId: option.id,
      });

      sources.push(s);
      canvas.addObject(s);
    }
    const parentThis = this;
    // kaynak elemanların sürükleme özelliklerinin ayarlanması
    const openDrawingMode= this.openDrawingMode;
    const closeDrawingMode = this.closeDrawingMode;
    const selectedTool= this.selectedTool;
    sources.forEach(function (source) {
      source.on('mousedown:before', (o: any) => {
        openDrawingMode(canvas, selectedTool);
      });
      source.on('mousedown', function () {
        if (currentPageItem.hasCompleteButton) {
          const otherGroupItems = canvas
            .getObjects()
            .filter(
              (x) => x.optiongroup === source.optiongroup && x.id !== source.id,
            );
          for (const item of otherGroupItems) {
            item.set('fill', '');
            item.set('isSelected', false);
          }
          source.set('fill', '#00cfe85c');
          source.set('isSelected', true);
        } else {
          source.set('isSelected', true);
          parentThis.playSound(source.isCorrect);
          if (source.isCorrect) {
            source.set('fill', '#28c76f6e');
          } else {
            source.set('fill', '#ea5455a6');
            const correctOne = canvas
              .getObjects()
              .find((x) => x.optiongroup === source.optiongroup && x.isCorrect);
            if (correctOne) {
              correctOne.set('fill', '#28c76f6e');
            }
          }
        }
      });
      source.on('mouseup', function () {
        closeDrawingMode(canvas,selectedTool);
      });
    });
    // this.renderActivityFiles(props, opts);
  }
  onReset() {
    this.resetOpenedAnswers();
    const canvas = this._canvas;
    const selectedItems = canvas
      .getObjects()
      .filter((x) => x.id && x.id.includes('source'));
    for (const item of selectedItems) {
      item.set('fill', '');
      item.set('isSelected', false);
    }
    canvas.canvasRenderAll();
  }
  onComplete() {
    const answeredQuestions = this._canvas
      .getObjects()
      .filter((x) => x.isSelected);
    const correctAnswerCount = answeredQuestions.filter(
      (x) => x.isCorrect,
    ).length;
    const wrongAnswerCount = answeredQuestions.filter(
      (x) => !x.isCorrect,
    ).length;
    for (const option of this.options) {
      const item = this._canvas
        .getObjects()
        .find((x) => x.id === `source-${option.id}`);
      const isEmpty =
        answeredQuestions.filter((x) => x.optiongroup === option.group)
          .length === 0;
      if (isEmpty && item.isCorrect) {
        item.set('fill', '#ddca1fb5');
      } else if (!isEmpty && item.isCorrect) {
        item.set('fill', '#28c76f6e');
      } else if (!isEmpty && !item.isCorrect && item.isSelected) {
        item.set('fill', '#ea5455a6');
      }
    }
    this._canvas.canvasRenderAll();
  }

  onShowAnswer = async () => {
    this.onReset();
    const canvas = this._canvas;
    const selectedItems = canvas.getObjects().filter((x) => x.isCorrect);
    for (const item of selectedItems) {
      item.set('fill', '#28c76f6e');
      item.set('isSelected', true);
      this.addOpenedAnswers(item.optionId);
    }
    this.playSound('solve');
    canvas.canvasRenderAll();
  };
  onShowPreviousAnswer = async () => {
    const canvas = this._canvas;
    const showedItems = canvas
      .getObjects()
      .filter(
        (x) => x.isCorrect && this.getOpenedAnswers().includes(x.optionId),
      );
    if (showedItems.length > 0) {
      const item = showedItems[showedItems.length - 1];
      item.set('fill', '');
      item.set('isSelected', false);
      this.removeOpenedAnswers(item.optionId);
      canvas.canvasRenderAll();
    }
  };
  onShowNextAnswer = async () => {
    const canvas = this._canvas;
    const notShowedItems = canvas
      .getObjects()
      .filter(
        (x) => x.isCorrect && !this.getOpenedAnswers().includes(x.optionId),
      );
    if (notShowedItems.length > 0) {
      const item = notShowedItems[0];
      item.set('fill', '#28c76f6e');
      item.set('isSelected', true);
      this.playSound('solve');
      this.addOpenedAnswers(item.optionId);
      canvas.canvasRenderAll();
    }
  };
  doMouseDown(o:any) {}

  doMouseMove(o: any) {}

  doMouseUp(o: any) {}
  destroy() {}
}

export default FindCorrectOne;
